import { mapGetters } from 'vuex'

import { joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request, services } from '@/utils'

import render from './render'

export default {
  name: 'ProvidersPricesImport',

  props: {
    ProviderId: String,

    disabled: Boolean
  },

  data() {
    return {
      showFileManager: false,
      showResultDialog: false,
      loading: false,

      result: undefined
    }
  },

  computed: {
    ...mapGetters({ file: 'file/file' })
  },

  watch: {
    file: {
      async handler(file) {
        this.import(file.id)

        this.showFileManager = false
      },
      deep: true
    }
  },

  methods: {
    async import(fileId) {
      try {
        this.showFileManager = false
        this.showResultDialog = true
        this.loading = true
        const response = await request.update(joinURLPath(services.providersPrices, 'import'), {
          body: {
            ProviderId: this.ProviderId,
            fileId
          }
        })
        if (response) {
          this.result = response?.result
          this.$emit('import', response?.result)
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
